import EditDialog from "@/components/common/EditDialog";
import type {
    ExtendedEventViewT,
    ExtendedInjectionViewT,
} from "@/types/database/events";
import InjectionDetailsForm from "./InjectionDetailsForm";
import InjectionDetailsList from "./InjectionDetailsList";
import InjectionForm from "./InjectionForm";
import InjectionMainInfo from "./InjectionMainInfo";

interface Props {
    diaryId: string;
    trackerId?: string;
    eventId: string;
    organisationId: string;
    injection: ExtendedInjectionViewT;
    event: ExtendedEventViewT;
    editable: boolean;
}

const InjectionItem = (props: Props) => {
    const { injection, editable, diaryId, eventId, organisationId } = props;

    return (
        <>
            <EditDialog
                label="Injection"
                info={<InjectionMainInfo injection={injection} />}
                editable={editable}
            >
                <InjectionForm
                    injection={injection}
                    injectionId={injection.injection_id}
                    diaryId={diaryId}
                    eventId={eventId}
                    organisationId={organisationId}
                    isDialog={true}
                />
            </EditDialog>

            <EditDialog
                label="Injection Details"
                info={
                    <InjectionDetailsList
                        injectionDetails={injection.injection_details ?? []}
                    />
                }
                editable={editable}
            >
                <InjectionDetailsForm
                    injection={injection}
                    diaryId={diaryId}
                    injectionId={injection.injection_id}
                    eventId={eventId}
                    isDialog={true}
                />
            </EditDialog>
        </>
    );
};

export default InjectionItem;
